/**
 * SendMailButton — opens the full MailEditorModal (R5) to send the offer
 * email. Disabled when user has no email_settings configured.
 */
import { useEffect, useState } from "react";
import axios from "axios";
import { Mail } from "lucide-react";
import { useAuth, hasRole } from "../../context/AuthContext";
import MailEditorModal from "../MailEditorModal";

import { API } from "../../lib/backend";

export default function SendMailButton({ offerId, defaultTo, subject, body }) {
  const { user } = useAuth();
  const canSend = hasRole(user, "commercial", "titolare");
  const [smtpReady, setSmtpReady] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!canSend) return;
    axios
      .get(`${API}/auth/email-settings`, { withCredentials: true })
      .then((r) => setSmtpReady(r.data?.settings?.password_configured === true))
      .catch(() => setSmtpReady(false));
  }, [canSend]);

  if (!canSend) return null;

  const disabled = !smtpReady || !body || !defaultTo;
  const tooltip = !smtpReady
    ? "Configura SMTP in Impostazioni → Email per attivare"
    : !defaultTo
    ? "Email cliente mancante"
    : !body
    ? "Messaggio vuoto"
    : "Invia messaggio via mail al cliente";

  return (
    <>
      <button
        type="button"
        disabled={disabled}
        onClick={() => setOpen(true)}
        className="h-7 px-2.5 rounded text-[11px] font-medium inline-flex items-center gap-1 text-white disabled:opacity-50 disabled:cursor-not-allowed"
        style={{ background: "var(--accent-primary)" }}
        title={tooltip}
        data-testid="send-mail-btn"
      >
        <Mail className="h-3 w-3" />
        Invia mail
      </button>
      <MailEditorModal
        open={open}
        onClose={() => setOpen(false)}
        offerId={offerId}
        from={user?.email}
        defaultTo={defaultTo || ""}
        defaultSubject={subject || ""}
        defaultBody={body || ""}
      />
    </>
  );
}
